import { BrowserDetectionService } from '@repo/roche-xx-shared';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { HashRouter, Route, Routes } from 'react-router-dom';
import { StaticRouter } from 'react-router-dom/server';
import { DataSearch, DataSearchProps } from './data-search';

const queryClient = new QueryClient();

export const DataSearchView = <TItem,>(props: DataSearchProps<TItem>): JSX.Element => {
  if (BrowserDetectionService.isBrowserContext()) {
    return (
      <QueryClientProvider client={queryClient}>
        <HashRouter basename='/'>
          <Routes>
            <Route
              path={`/${props.tabName}?/:tab?/${props.subtabName}?/:subtab?/${props.queryName}?/:query?/${props.pageName}?/:page?`}
              element={<DataSearch {...props} />}
            />
          </Routes>
        </HashRouter>
      </QueryClientProvider>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <StaticRouter location='/'>
        <Routes>
          <Route path='*' element={<DataSearch {...props} />} />
        </Routes>
      </StaticRouter>
    </QueryClientProvider>
  );
};
